import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      createdDate: periodFormat(filter.createdDate),
      activityType: filter.activityType[0] ? filter.activityType : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      arrChanged: {
        from: filter.arrChanged.from ? filter.arrChanged.from : '*',
        to: filter.arrChanged.to ? filter.arrChanged.to : '*'
      },
      arrStatus: filter.arrStatus[0] ? filter.arrStatus : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
